const Edu = () => {
  const eduList = {
    edu: [
      {
        title: "Java & SpringBoot로 시작하는 웹 프로그래밍",
        period: "2021.08 - 2021.10",
        at: "패스트캠퍼스",
      },
      {
        title: "반응형웹디자인(웹퍼블리셔)UI/UX 프론트엔드 양성과정",
        period: "2020.03 - 2020.07",
        at: "더조은컴퓨터아트학원",
      },
      {
        title: "강원대학교 컴퓨터정보통신공학과 졸업",
        period: "2014.03 - 2023.02",
        at: "강원대학교",
      },
    ],
  };
  return (
    <section id="edu" className="edu">
      <strong className="section_tit">
        <img src="/book.png" alt="교육 아이콘" />
        <span>교육</span>
      </strong>
      <ul>
        {eduList.edu.map((edu, idx) => (
          <li
            key={idx}
            className="flex flex-col justify-between py-2 md:flex-row"
          >
            <p className="text-base pb-1 break-word md:text-lg md:pb-0">
              {edu.title}
            </p>
            <div className="text-sm text-zinc-300">
              <span className="pr-6">{edu.at}</span>
              <span>{edu.period}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Edu;
